import type { ReactElement } from 'react';

import { BodyCopy } from '@xing-com/typography';

import * as Styled from './card-pricing.styled';
import type { CardPricingProps } from './card-pricing.types';

export type { CardPricingProps } from './card-pricing.types';

export const CardPricing = ({
  price,
  previousPrice,
}: CardPricingProps): ReactElement => (
  <Styled.Pricing>
    <BodyCopy size="xlarge" noMargin>
      {price}
    </BodyCopy>
    <BodyCopy size="small" lineHeight="dense" noMargin>
      {previousPrice}
    </BodyCopy>
  </Styled.Pricing>
);
